// Critérios observáveis do contrato NEXTGREEN. Não substituem seus filtros privados.
const rounded = (n) => Math.round((n + Number.EPSILON) * 100) / 100;
const finite = (n) => typeof n === "number" && Number.isFinite(n);
export function evaluateBrunoPreference(confirmation) {
  const valid =
    finite(confirmation) && confirmation >= 0 && confirmation <= 100;
  return {
    id: "bruno-confirmacao-v1",
    source: "https://www.youtube.com/watch?v=6YVwDaoq0-c&t=315s",
    minimum_exclusive: 80,
    confirmation: valid ? confirmation : null,
    accepted: valid && confirmation > 80,
    status: valid ? (confirmation > 80 ? "matched" : "mismatch") : "unknown",
    reason: !valid
      ? "Confirmação ausente ou inválida."
      : confirmation > 80
        ? "Passou no filtro do vídeo: confirmação acima de 80%."
        : "Recusado pelo filtro do vídeo: exige confirmação acima de 80%.",
  };
}
export function directionConfirmationBase(direction, percentages) {
  const key =
    direction === "CALL"
      ? "percentual_verdes"
      : direction === "PUT"
        ? "percentual_vermelhas"
        : null;
  if (!key || !finite(percentages?.[key]))
    throw new Error("Direção ou percentuais ausentes.");
  return rounded(percentages[key]);
}
export function auditOriginalCriteria(signal) {
  const indicators = signal.indicadores || {};
  const percentages = signal.percentuais || {};
  let base = null;
  try {
    base = directionConfirmationBase(signal.direcao, percentages);
  } catch {
    /* Critério desconhecido. */
  }
  const reportedBase = finite(signal.confirmacao_base)
    ? signal.confirmacao_base
    : null;
  const confirmation = finite(signal.confirmacao) ? signal.confirmacao : null;
  const adjustment =
    confirmation !== null && reportedBase !== null
      ? rounded(confirmation - reportedBase)
      : null;
  return {
    version: "criterios-observados-v1",
    can_publish_live: false,
    calculated_base: base,
    reported_adjustment: adjustment,
    checks: [
      {
        id: "window",
        label: "Janela de análise",
        status: percentages.total_velas === 15 ? "matched" : "unknown",
        value: percentages.total_velas,
        detail: "15 velas; a vela em formação fica fora do cálculo.",
      },
      {
        id: "base",
        label: "Confirmação base",
        status:
          base === null || reportedBase === null
            ? "unknown"
            : Math.abs(base - reportedBase) <= 0.01
              ? "matched"
              : "mismatch",
        value: base,
        detail:
          signal.direcao === "PUT"
            ? "PUT: percentual de velas vermelhas."
            : signal.direcao === "CALL"
              ? "CALL: percentual de velas verdes."
              : "Direção não informada.",
      },
      {
        id: "minimum",
        label: "Confirmação mínima anunciada",
        status:
          confirmation === null
            ? "unknown"
            : confirmation >= 65
              ? "matched"
              : "mismatch",
        value: confirmation,
        detail:
          "≥ 65%: limite citado pelo cliente original; demais filtros do servidor ainda não confirmados.",
      },
      {
        id: "adjustment",
        label: "Ajuste retornado pelo original",
        status: adjustment === null ? "unknown" : "reported",
        value: adjustment,
        detail:
          "Diferença entre confirmação final e base. A regra que aplica o ajuste ainda não foi confirmada.",
      },
      {
        id: "operator_preference",
        label: "Filtro aplicado — Bruno SS",
        status: evaluateBrunoPreference(confirmation).status,
        value: confirmation,
        detail:
          "Exige confirmação > 80%. Preferência demonstrada no vídeo; não é o filtro interno do NEXTGREEN.",
      },
      {
        id: "rsi",
        label: "RSI",
        status:
          typeof indicators.confirmacao_rsi === "boolean"
            ? "reported"
            : "unknown",
        value: indicators.rsi,
        flag: indicators.confirmacao_rsi ?? null,
        detail:
          "O original pode enviar sinal com RSI não confirmado. Limites de aprovação não expostos.",
      },
      {
        id: "adx",
        label: "ADX",
        status:
          typeof indicators.confirmacao_adx === "boolean"
            ? "reported"
            : "unknown",
        value: indicators.adx,
        flag: indicators.confirmacao_adx ?? null,
        detail: `+DI ${finite(indicators.plus_di) ? indicators.plus_di : "?"} · −DI ${finite(indicators.minus_di) ? indicators.minus_di : "?"}. Limites de aprovação não expostos.`,
      },
      {
        id: "volatility",
        label: "Volatilidade",
        status: "unknown",
        value: null,
        detail:
          "A frase da tela é fixa. O contrato não informa valor, limite ou aprovação deste filtro.",
      },
      {
        id: "ranking",
        label: "Escolha do melhor ativo",
        status: "unknown",
        value: null,
        detail:
          "O original não retorna os candidatos descartados nem a regra de desempate.",
      },
    ],
    blockers: [
      "Limites e combinações RSI/ADX",
      "Regra do ajuste de confirmação",
      "Filtros de volatilidade e outros vetos",
      "Ranking entre ativos",
    ],
  };
}
